<template>
  <div class="overview">
    <v-card flat>
      <v-card-text>
        <DataTable
          :optionsPassed="options"
          :totalLogs="totalLogs"
          :logs="logs"
          :searchPassed="search"
          :headerSelects="headerSelects"
          :headersTable="headersTable"
          v-on:getECareApiLogs="getECareApiLogs"
          :loading="loading"
        >
          <template #title> ECare API Logs </template>
          <template #headerButtons>
            <v-btn
              color="primary"
              class="mr-2"
              small
              :loading="downloadLoading"
              @click="exportToExcel"
            >
              Export to excel
            </v-btn>
          </template>
        </DataTable></v-card-text
      ></v-card
    >
  </div>
</template>

<script>
import DataTable from "./ECareLogsTable.vue";

// var searchTimeOut;

export default {
  name: "ECareLogs",
  components: {
    DataTable,
  },
  data: () => ({
    logs: [],

    search: {
      salesOrganisation: null,
      organisation: null,
      country: null,
      responseStatus: "",
      fromDate: null,
      toDate: null,
      sbmProfile: null,
      durationMs: null,
    },
    options: {
      /*itemsPerPage: 15*/
    },
    totalLogs: null,
    headerSelects: {
      organisation: [],
      salesOrganisation: [
        { text: "Daikin Europe", value: "daikin-europe" },
        { text: "Daikin Applied", value: "daikin-applied" },
        { text: "Daikin Europe Transport", value: "daikin-europe-transport" },
      ],
      country: [],
      timestamp: [],
      endpiont: [],
      sourceService: [],
      responseStatus: [
        { text: "Success (2xx)", value: 200 },
        { text: "Client errors (4xx)", value: 400 },
        { text: "Server errors (5xx)", value: 500 },
      ],
    },

    headersTable: [
      {
        text: "",
        value: "actions",
        sortable: false,
        align: "center",
        width: "50px",
      },
      {
        text: "Organisation",
        value: "organisation",
        type: "select",
        itemTitle: "text",
        itemValue: "value",
      },
      {
        text: "Sales Organisation",
        value: "salesOrganisation",
        type: "select",
      },
      {
        text: "SBMProfile",
        value: "sbmProfile",
        type: "select",
        itemTitle: "text",
        itemValue: "value",
      },
      {
        text: "Country",
        value: "country",
        type: "select",
        itemTitle: "text",
        itemValue: "value",
      },
      {
        text: "Timestamp",
        value: "timestamp",
      },
      {
        text: "Response Status",
        value: "responseStatus",
        type: "select",
      },
      {
        text: "Log Time",
        value: "durationMs",
      },
    ],
    loading: false,
    downloadLoading: false,
  }),
  computed: {},
  methods: {
    exportToExcel() {
      this.downloadLoading = true;
      this.$api
        .exportLogsTechnical(this.search)
        .finally(() => (this.downloadLoading = false));
    },
    getECareApiLogs(tableSearch) {
      this.loading = true;
      this.search = tableSearch.search;
      this.options = tableSearch.options;

      const params = {
        fromDate: this.search.fromDate || undefined,
        toDate: this.search.toDate || undefined,
        responseStatus: this.search.responseStatus || undefined,
        country: this.search.country || undefined,
        salesOrg: this.search.salesOrganisation || undefined,
        organisationId: this.search.organisation || undefined,
        sbmProfileId: this.search.sbmProfile || undefined,
        durationMs: this.search.durationMs || undefined,
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        sortBy: this.options.sortBy?.[0] || null,
        sortDescending: this.options.sortDesc?.[0] || false,
      };

      this.$api
        .getECareApiLogs(params)
        .then((resp) => {
          //console.log("logs fetched:", resp.data);
          this.logs = resp.data.items.map((log) => ({
            ...log,
            organisation: log.organisationName,
            sbmProfile: log.sbmProfileName,
            durationMs: log.durationMs
              ? (log.durationMs / 1000).toFixed(2)
              : null,
            timestamp: log.timestamp ? log.timestamp.slice(0, 19) : null,
          }));
          this.totalLogs = resp.data.totalItems;
        })
        .finally(() => (this.loading = false));
    },
  },

  mounted() {},
  watch: {
    $route(to) {
      if (to.name === "ECareLogs") {
        this.getECareApiLogs({
          search: this.search || {},
          options: this.options || {},
        });
      }
    },
  },
};
</script>